import React, { useEffect, useMemo, useState } from "react";
import styles from "./ui.module.scss";
import { TelegramShareButton, TwitterShareButton, VKShareButton } from "next-share";
import { useEventStore } from "../../store";
import moment from "moment";
import { Popup } from "semantic-ui-react";
import { TRecipientData } from "../../../../stores/RecipientStore";
import { useRouter } from "next/router";
import { ShareTGIcon } from "../../../vmesteOkean/leftMenu/icons/ShareTG";

type TShareLink = {
  type: "vk" | "fb" | "tw" | "tg" | "link";
};

const ShareLink: React.FC<TShareLink> = ({ type }) => {
  const [open, setOpen] = useState(false);
  let timer;

  useEffect(() => {
    return () => {
      clearTimeout(timer);
    };
  }, []);

  const onClick = () => {
    setOpen(true);
    if (typeof navigator !== "undefined") {
      navigator.clipboard.writeText(window.location.href);
    }
    timer = setTimeout(() => {
      setOpen(false);
    }, 1500);
  };

  const text = useMemo(() => {
    switch (type) {
      case "vk":
        return "VK";
      case "fb":
        return "Facebook";
      case "tw":
        return "Twitter";
      case "tg":
        return "Telegram";
      case "link":
        return "Ссылка";
    }
  }, [type]);

  const img = useMemo(() => {
    switch (type) {
      case "vk":
        return "/static/images/eventIcons/BVK.png";
      case "fb":
        return "/static/images/eventIcons/BFB.svg";
      case "tw":
        return "/static/images/eventIcons/BTW.svg";
      case "tg":
        return "/static/images/icons/newTG.svg";
      case "link":
        return "/static/images/eventIcons/BL.svg";
    }
  }, [type]);

  if (type === "link") {
    return (
      <Popup
        inverted
        open={open}
        basic
        style={{ backgroundColor: "#333333", zIndex: 10000 }}
        position={"top center"}
        trigger={
          <div onClick={onClick} className={styles.ShareLink}>
            <div className={styles.ShareLink_Image}>
              <img src={img} alt={text} />
            </div>
            <div className={styles.ShareLink_Text}>
              <span>{text}</span>
            </div>
          </div>
        }
      >
        Ссылка скопирована
      </Popup>
    );
  }

  return (
    <div className={styles.ShareLink}>
      <div className={styles.ShareLink_Image}>
        <img src={img} alt={text} />
      </div>
      <div className={styles.ShareLink_Text}>
        <span>{text}</span>
      </div>
    </div>
  );
};

export const Link = ({ link, className = "styles.EventShareBlock_Links_Link" }) => {
  return (
    <div className={className}>
      <img src={link} alt={link} />
    </div>
  );
};

export const CustomLink = ({
  link,
  className = "styles.EventShareBlock_Links_Link",
}) => {
  const [open, setOpen] = useState(false);
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    return () => {
      setTimer(null);
    };
  }, []);

  const onClick = () => {
    setOpen(true);
    if (typeof navigator !== "undefined")
      navigator.clipboard.writeText(window.location.href);
    setTimer(
      setTimeout(() => {
        setOpen(false);
      }, 1500)
    );
  };

  return (
    <Popup
      inverted
      open={open}
      basic
      style={{ backgroundColor: "#333333" }}
      position={"top center"}
      trigger={
        <div
          onClick={onClick}
          style={{ cursor: "pointer" }}
          className={className}
        >
          <img src={link} alt={link} />
        </div>
      }
    >
      Ссылка скопирована
    </Popup>
  );
};

export const SHARE_LINKS = [
  {
    key: "VK",
    component: (url, name, key, className = null) => (
      <VKShareButton
        key={key}
        title={name}
        url={url}
        image={"/static/images/metaImg.png"}
      >
        <Link className={className} link={"/static/images/eventIcons/VK.svg"} />
      </VKShareButton>
    ),
    bigComponent: (url, name, key) => (
      <VKShareButton
        key={key}
        title={name}
        url={url}
        image={"/static/images/metaImg.png"}
      >
        <ShareLink type={"vk"} />
      </VKShareButton>
    ),
  },
  // {
  //   key: "fb",
  //   component: (url, name, key, className = null) => (
  //     <FacebookShareButton key={key} title={name} url={url} quote={name}>
  //       <Link className={className} link={"/static/images/eventIcons/fb.svg"} />
  //     </FacebookShareButton>
  //   ),
  //   bigComponent: (url, name, key) => (
  //     <FacebookShareButton key={key} title={name} url={url} quote={name}>
  //       <ShareLink type={"fb"} />
  //     </FacebookShareButton>
  //   ),
  // },
  // {
  //   key: "twitter",
  //   component: (url, name, key, className = null) => (
  //     <TwitterShareButton key={key} title={name} url={url}>
  //       <Link
  //         className={className}
  //         link={"/static/images/eventIcons/twitter.svg"}
  //       />
  //     </TwitterShareButton>
  //   ),
  //   bigComponent: (url, name, key) => (
  //     <TwitterShareButton key={key} title={name} url={url}>
  //       <ShareLink type={"tw"} />
  //     </TwitterShareButton>
  //   ),
  // },
  {
    key: "telegram",
    component: (url, name, key, className = null) => (
      <TelegramShareButton
        key={key} title={name} url={url}
      >
        <Link className={className} link={"/static/images/icons/newTG.svg"} />
      </TelegramShareButton>
    ),
    bigComponent: (url, name, key) => (
      <TelegramShareButton key={key} title={name} url={url}>
        <ShareLink type={"tg"} />
      </TelegramShareButton>
    ),
  },
  {
    key: "Link",
    component: (url, name, key, className = null) => (
      <CustomLink
        className={className}
        key={key}
        link={"/static/images/eventIcons/Link.svg"}
      />
    ),
    bigComponent: (url, name, key) => <ShareLink type={"link"} key={key} />,
  },
];

const EventShareBlock: React.FC<{ data?: TRecipientData }> = ({
  data = null,
}) => {
  const router = useRouter();
  const currPath = useMemo(() => {
    if (typeof window !== "undefined") {
      return `${window.location.origin}${router.asPath}`;
    } else {
      return `https://donorsearch.org${router.asPath}`;
    }
  }, [router]);
  const { eventData } = useEventStore();

  const content = useMemo(() => {
    if (data?.status)
      switch (data.status) {
        case "search_in_progress":
          return `Поиск доноров продолжается до ${moment(data.last_date).format(
            "DD MMMM YYYY"
          )} | DonorSearch.org`;
        case "donors_found":
          return `Доноры найдены ${moment(data.last_date).format(
            "DD MMMM YYYY"
          )} | DonorSearch.org`;
        case "search_completed":
          return `Поиск завершен ${moment(data.last_date).format(
            "DD MMMM YYYY"
          )} | DonorSearch.org`;
      }
    else
      return `${eventData.name} | ${moment(eventData.start_date).format(
        "DD MMMM"
      )} | DonorSearch.org`;
  }, [data, eventData]);

  return (
    <div className={styles.EventShareBlock}>
      <div className={styles.EventShareBlock_Default}>Поделиться</div>
      <div className={styles.EventShareBlock_Links}>
        {SHARE_LINKS.map((item) =>
          item.component(currPath, content, `key_${item.key}`)
        )}
      </div>
    </div>
  );
};

export default EventShareBlock;
